import classnames from 'classnames/bind'

// Components
import Icon from '@/assets/icons'

// Styles
import { useTranslation } from 'next-i18next'
import styles from './style.module.scss'

const cx = classnames.bind(styles)

type ContentMapType = Record<
  'lives' | 'shop',
  {
    icon: React.ReactNode
    title: string
    description: string
  }
>

const Empty = ({ type }: { type: keyof ContentMapType }) => {
  const { t } = useTranslation()
  const CONTENT_MAP: ContentMapType = {
    lives: {
      icon: <Icon.MyLiveListEmpty />,
      title: t('Profile_Empty_Live_Title'),
      description: '',
    },
    shop: {
      icon: <Icon.ShopEmpty />,
      title: t('Profile_Empty_Shop_Title'),
      description: t('Profile_Empty_Shop_Description'),
    },
  }

  return (
    <div className={cx('empty')}>
      <div className={cx('empty-icon')}>{CONTENT_MAP[type].icon}</div>
      <div className={cx('empty-title')}>{CONTENT_MAP[type].title}</div>
      <div className={cx('empty-description')}>{CONTENT_MAP[type].description}</div>
    </div>
  )
}

export default Empty
